import React from 'react';
import { Link } from 'react-router-dom';

/** German body for /privacy (deduplicated from main page switch). */
export const PrivacyContentDe: React.FC = () => (
  <>
    <p>
      <strong>Datenschutzerklärung für I Think It’s You</strong>
    </p>
    <p>
      <em>Stand: 23. April 2026</em>
    </p>

    <h2>1. Wer wir sind</h2>
    <p>
      Diese Datenschutzerklärung informiert über die Verarbeitung personenbezogener Daten bei der
      Nutzung der Website, mobiler Anwendungen und sonstiger digitaler Dienste von{' '}
      <strong>I Think It’s You</strong>, handelnd unter <em>I Think It’s You</em> und{' '}
      <em>Event Partner Austria Verein</em> („wir“, „uns“, „unser“).
    </p>
    <p>
      <strong>Verantwortlicher:</strong>
      <br />
      Event Partner Austria Verein
      <br />
      Kwizdastrasse 9/11
      <br />
      2100 Korneuburg
      <br />
      Österreich
    </p>
    <p>
      E-Mail:{' '}
      <a href="mailto:contact@i-think-its-you.at">contact@i-think-its-you.at</a>
      <br />
      Kontaktformular:{' '}
      <Link to="/contact">Kontaktformular</Link>
    </p>
    <p>
      <strong>Datenschutzbeauftragte/r:</strong>
      <br />
      Michael Kremnitzer
      <br />
      <a href="mailto:michael.kremnitzer@eventpartner.at">michael.kremnitzer@eventpartner.at</a>
    </p>

    <h2>2. Für wen diese Datenschutzerklärung gilt</h2>
    <p>Diese Datenschutzerklärung gilt für:</p>
    <ul>
      <li>Besucherinnen und Besucher unserer Website und App</li>
      <li>registrierte Nutzerinnen und Nutzer</li>
      <li>Personen, die mit uns Kontakt aufnehmen</li>
      <li>Personen, deren Daten in Meldungen, Missbrauchsanzeigen oder Supportanfragen enthalten sind</li>
      <li>sowie Personen, die in öffentlichen Beiträgen beschrieben oder erwähnt werden können</li>
    </ul>
    <p>
      Gerade weil I Think It’s You ein Dienst für „missed connections“ ist, können wir unter Umständen
      auch Daten über nicht registrierte Dritte verarbeiten.
    </p>

    <h2>3. Welche Daten wir verarbeiten</h2>

    <h3>3.1 Daten, die Sie uns direkt mitteilen</h3>
    <ul>
      <li>Kontodaten (Benutzername, E-Mail-Adresse, Passwort-Hash, Registrierungszeitpunkt)</li>
      <li>Profildaten (Anzeigename, Profilbild, Sprache, Stadt/Region)</li>
      <li>Inhaltsdaten (Beiträge, Nachrichten, Kommentare etc.)</li>
      <li>Kommunikationsdaten (Supportanfragen, Beschwerden etc.)</li>
      <li>Zahlungs- und Transaktionsdaten (Metadaten)</li>
      <li>Daten aus Social-Login-Funktionen</li>
    </ul>

    <h3>3.2 Daten über andere Personen</h3>
    <ul>
      <li>Beschreibung einer Begegnung</li>
      <li>Ort und Zeitpunkt</li>
      <li>äußerlich erkennbare Merkmale</li>
      <li>Kommunikationsverlauf</li>
      <li>Angaben aus Meldungen oder Beschwerden</li>
    </ul>
    <blockquote className="static-page-quote">
      <p>
        <strong>Hinweis:</strong> Der Dienst ist <strong>nicht dafür gedacht</strong>, identifizierende
        oder sensible Daten Dritter öffentlich zu machen.
      </p>
    </blockquote>

    <h3>3.3 Automatisch erfasste Daten</h3>
    <ul>
      <li>IP-Adresse</li>
      <li>Zeitstempel</li>
      <li>Browsertyp und Version</li>
      <li>Gerätetyp, Betriebssystem</li>
      <li>Referrer-URL</li>
      <li>Logdaten</li>
      <li>Cookie-, Consent- und Session-Daten</li>
      <li>ungefähre Standortdaten (IP-basiert)</li>
      <li>präzisere Standortdaten (nur bei Zustimmung)</li>
    </ul>

    <h3>3.4 Daten von Dritten</h3>
    <ul>
      <li>Social-Login-Anbieter</li>
      <li>Zahlungsdienstleister</li>
      <li>andere Nutzer (Meldungen)</li>
      <li>technische Dienstleister</li>
      <li>Behörden oder Gerichte</li>
    </ul>

    <h2>4. Zwecke und Rechtsgrundlagen der Verarbeitung</h2>
    <p>Wir verarbeiten Daten nur auf Grundlage von:</p>
    <ul>
      <li>Einwilligung</li>
      <li>Vertragserfüllung</li>
      <li>rechtlicher Verpflichtung</li>
      <li>berechtigten Interessen</li>
    </ul>

    <h3>4.1 Bereitstellung des Dienstes</h3>
    <ul>
      <li>Konto erstellen und verwalten</li>
      <li>Plattform betreiben</li>
      <li>Beiträge veröffentlichen</li>
      <li>Kommunikation ermöglichen</li>
    </ul>
    <p>
      <strong>Rechtsgrundlage:</strong> Vertragserfüllung
    </p>

    <h3>4.2 Betrieb des „missed connections“-Dienstes</h3>
    <ul>
      <li>öffentliche Beiträge anzeigen</li>
      <li>Suchfunktionen bereitstellen</li>
      <li>Kontaktanbahnungen ermöglichen</li>
    </ul>
    <p>
      <strong>Rechtsgrundlage:</strong> berechtigte Interessen
    </p>

    <h3>4.3 Moderation &amp; Sicherheit</h3>
    <ul>
      <li>Missbrauch erkennen</li>
      <li>Inhalte prüfen und entfernen</li>
      <li>Systeme schützen</li>
    </ul>
    <p>
      <strong>Rechtsgrundlage:</strong> berechtigte Interessen
    </p>

    <h3>4.4 Kommunikation &amp; Support</h3>
    <ul>
      <li>Anfragen beantworten</li>
      <li>Beschwerden bearbeiten</li>
    </ul>
    <p>
      <strong>Rechtsgrundlage:</strong> Vertrag, Pflicht oder berechtigtes Interesse
    </p>

    <h3>4.5 Standortfunktionen</h3>
    <ul>
      <li>regionale Zuordnung</li>
      <li>lokale Suche</li>
    </ul>
    <p>
      <strong>Rechtsgrundlage:</strong> Vertrag / Einwilligung
    </p>

    <h3>4.6 Marketing &amp; Newsletter</h3>
    <p>nur mit Einwilligung oder gesetzlicher Grundlage</p>
    <p>Widerruf jederzeit möglich.</p>

    <h3>4.7 Analyse &amp; Weiterentwicklung</h3>
    <ul>
      <li>Nutzung verstehen</li>
      <li>Fehler analysieren</li>
      <li>Funktionen verbessern</li>
    </ul>
    <p>
      <strong>Rechtsgrundlage:</strong> berechtigte Interessen / Einwilligung
    </p>

    <h3>4.8 Rechtliche Pflichten</h3>
    <ul>
      <li>gesetzliche Vorgaben erfüllen</li>
      <li>Ansprüche durchsetzen</li>
    </ul>

    <h2>5. Besondere Kategorien personenbezogener Daten</h2>
    <p>Bitte übermitteln Sie <strong>keine sensiblen Daten</strong> wie:</p>
    <ul>
      <li>Gesundheitsdaten</li>
      <li>religiöse Überzeugungen</li>
      <li>biometrische Daten</li>
      <li>sexuelle Orientierung</li>
    </ul>
    <p>
      Falls solche Daten freiwillig veröffentlicht werden, verarbeiten wir sie nur im rechtlich
      zulässigen Rahmen.
    </p>

    <h2>6. Öffentliche Bereiche</h2>
    <ul>
      <li>Beiträge sind öffentlich sichtbar</li>
      <li>Inhalte können geteilt oder indexiert werden</li>
      <li>Rechte Dritter müssen beachtet werden</li>
    </ul>
    <p>
      <strong>Empfehlung:</strong> Keine identifizierenden oder sensiblen Daten veröffentlichen.
    </p>

    <h2 id="cookies">7. Cookies und ähnliche Technologien</h2>
    <p>Wir verwenden Cookies für:</p>
    <ul>
      <li>Betrieb der Plattform</li>
      <li>Sicherheit</li>
      <li>Analyse (nur mit Einwilligung)</li>
    </ul>
    <p>Widerruf jederzeit möglich.</p>
    <p>
      Links:
      <br />
      <a href="#cookies">Cookie-Hinweis</a>
      <br />
      <a href="#cookies">Cookie-Einstellungen</a>
    </p>

    <h2>8. Empfänger von Daten</h2>
    <p>Mögliche Empfänger:</p>
    <ul>
      <li>Hosting- und Cloud-Anbieter</li>
      <li>Zahlungsdienstleister</li>
      <li>Analyseanbieter</li>
      <li>Support-Dienstleister</li>
      <li>Behörden</li>
    </ul>

    <h2>9. Drittlandübermittlungen</h2>
    <p>Datenübermittlung erfolgt nur mit geeigneten Garantien, z.&thinsp;B.:</p>
    <ul>
      <li>EU-Angemessenheitsbeschluss</li>
      <li>EU-US Data Privacy Framework</li>
      <li>Standardvertragsklauseln</li>
    </ul>

    <h2>10. Speicherdauer</h2>
    <p>Daten werden gespeichert:</p>
    <ul>
      <li>nur so lange wie notwendig</li>
      <li>gemäß gesetzlicher Fristen</li>
    </ul>
    <p>Beispiele:</p>
    <ul>
      <li>Kontodaten: Dauer des Kontos</li>
      <li>Beiträge: bis Löschung</li>
      <li>Logs: begrenzte Zeit</li>
      <li>Buchhaltung: gesetzliche Fristen</li>
    </ul>

    <h2>11. Ihre Rechte</h2>
    <p>Sie haben das Recht auf:</p>
    <ul>
      <li>Auskunft</li>
      <li>Berichtigung</li>
      <li>Löschung</li>
      <li>Einschränkung</li>
      <li>Datenübertragbarkeit</li>
      <li>Widerspruch</li>
      <li>Widerruf</li>
    </ul>
    <p>
      <strong>Kontakt:</strong>{' '}
      <a href="mailto:contact@i-think-its-you.at">contact@i-think-its-you.at</a>
    </p>

    <h2>12. Beschwerderecht</h2>
    <p>
      Österreichische Datenschutzbehörde
      <br />
      Barichgasse 40–42
      <br />
      1030 Wien
      <br />
      Österreich
    </p>
    <p>
      E-Mail: <a href="mailto:dsb@dsb.gv.at">dsb@dsb.gv.at</a>
    </p>

    <h2>13. Pflicht zur Bereitstellung von Daten</h2>
    <p>Bestimmte Daten sind notwendig (z.&thinsp;B. Login-Daten).</p>
    <p>Ohne diese ist der Dienst eingeschränkt.</p>

    <h2>14. Automatisierte Entscheidungen</h2>
    <p>Wir nutzen Systeme zur:</p>
    <ul>
      <li>Spam-Erkennung</li>
      <li>Sortierung von Inhalten</li>
      <li>Sicherheit</li>
    </ul>
    <p>
      Keine ausschließlich automatisierten Entscheidungen mit erheblicher Wirkung (sofern nicht gesondert
      angegeben).
    </p>

    <h2>15. Datensicherheit</h2>
    <p>Maßnahmen:</p>
    <ul>
      <li>Verschlüsselung</li>
      <li>Zugriffsbeschränkung</li>
      <li>Backups</li>
      <li>Sicherheitsprozesse</li>
    </ul>
    <blockquote className="static-page-quote">
      <p>Absolute Sicherheit kann nicht garantiert werden.</p>
    </blockquote>

    <h2>16. Minderjährige</h2>
    <p>
      Der Dienst richtet sich <strong>nicht an unter 18-Jährige</strong>.
      <br />
      Daten werden bei Bekanntwerden gelöscht.
    </p>

    <h2>17. Änderungen</h2>
    <p>Diese Datenschutzerklärung kann angepasst werden.</p>
    <p>Aktuelle Version auf Website/App.</p>

    <h2>18. Kontakt</h2>
    <p>
      Event Partner Austria Verein
      <br />
      Kwizdastrasse 9/11
      <br />
      2100 Korneuburg
      <br />
      Österreich
    </p>
    <p>
      E-Mail: <a href="mailto:contact@i-think-its-you.at">contact@i-think-its-you.at</a>
    </p>
  </>
);
